import React, { useEffect, Component } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatIsNisa } from './components/WhatIsNisa';
import { Features } from './components/Features';
import { WhyNisaWorks } from './components/WhyNisaWorks';
import { VisionStory } from './components/VisionStory';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { AboutUs } from './pages/AboutUs';
import { PilotClosed } from './pages/PilotClosed';
import { ForSchools } from './pages/ForSchools';
import { Security } from './pages/Security';
import { SubProcessors } from './pages/SubProcessors';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ModalProvider } from './components/ModalContext';
import { BackgroundGraphics } from './components/BackgroundGraphics';
import { useAuthRedirect } from './hooks/useAuthRedirect';
// This component handles scrolling to anchors when the home page loads
const ScrollToAnchor = () => {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Remove the '#' character
      const id = hash.substring(1);
      // Give the DOM time to render before scrolling
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      // Scroll to top on route change when there's no hash
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};
// Component to handle auth redirect check
const AuthRedirectHandler = () => {
  useAuthRedirect();
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0">
      <ModalProvider data-id="element-1">
        <AuthRedirectHandler data-id="element-2" />
        <ScrollToAnchor data-id="element-3" />
        <div className="w-full min-h-screen bg-white text-gray-800 font-sans" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/terms" element={<>
                  <Header isStatic={true} data-id="element-7" />
                  <Terms data-id="element-8" />
                </>} data-id="element-6" />
            <Route path="/privacy" element={<>
                  <Header isStatic={true} data-id="element-10" />
                  <Privacy data-id="element-11" />
                </>} data-id="element-9" />
            <Route path="/about" element={<>
                  <Header isStatic={true} data-id="element-13" />
                  <AboutUs data-id="element-14" />
                </>} data-id="element-12" />
            <Route path="/pilot-program" element={<>
                  <Header isStatic={true} data-id="element-16" />
                  <PilotClosed data-id="element-17" />
                </>} data-id="element-15" />
            <Route path="/schools" element={<>
                  <Header isStatic={true} data-id="element-19" />
                  <ForSchools data-id="element-20" />
                </>} data-id="element-18" />
            <Route path="/security" element={<>
                  <Header isStatic={true} data-id="element-22" />
                  <Security data-id="element-23" />
                </>} data-id="element-21" />
            <Route path="/sub-processors" element={<>
                  <Header isStatic={true} data-id="element-25" />
                  <SubProcessors data-id="element-26" />
                </>} data-id="element-24" />
            <Route path="/" element={<>
                  <Header data-id="element-28" />
                  <main className="relative" data-id="element-29">
                    <BackgroundGraphics data-id="element-30" />
                    <div className="relative z-10" data-id="element-31">
                      <Hero data-id="element-32" />
                      <WhatIsNisa data-id="element-33" />
                      <Features data-id="element-34" />
                      <WhyNisaWorks data-id="element-35" />
                      <VisionStory data-id="element-36" />
                      <CallToAction data-id="element-37" />
                    </div>
                  </main>
                  <Footer data-id="element-38" />
                </>} data-id="element-27" />
          </Routes>
        </div>
      </ModalProvider>
    </BrowserRouter>;
}